import React from "react";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { performHttpRequest } from "../../../../axios/PerformHttpRequest";
import Input from "../../../core/Inputs/DefaultInput";
import style from "../../style.module.css";
import Modal from "react-bootstrap/Modal";
import Select from "react-select/creatable";
import Svg from "../../../component/Svg";

export const DuplicateRoi = ({ onClose, rowData }) => {
  const apiUrl = process.env.REACT_APP_NODE_API_URL;

  const [roiLanguageDuplicate, setRoiLanguageDuplicate] = useState([]);
  const [roiCurrencyDuplicate, setRoiCurrencyDuplicate] = useState([]);
  const [duplicateProjectName, setDuplicateProjectName] = useState("");
  const [duplicateCountry, setDuplicateCountry] = useState([]);
  const [duplicatePrimaryCurreny, setDuplicatePrimaryCurrency] = useState([]);
  const [duplicateAdditionaCurrency, setDuplicateAdditionalCurrency] = useState(
    []
  );
  const [duplicateDefaultLanguage, setDuplicateDefaultLanguage] = useState([]);

   useEffect(() => {
    getLanguageCurrencyAndTemplateDetail();
  }, []);

  const getLanguageCurrencyAndTemplateDetail = async () => {
    try {
      const response = await performHttpRequest(
        "GET",
        `${apiUrl}/roi/roiLanguage&Currency`,
        ""
      );

      setRoiLanguageDuplicate(response?.data?.languageResult);
      setRoiCurrencyDuplicate(response?.data?.currencyResult);
    } catch (error) {
      console.error("Error", error);
      toast.error(error?.response?.data?.responseText);
    }
  };

  const handleDuplicateCountryChange = (selectedOption) => {
    const selectedCountryChange = selectedOption?.map((option) => option.value);
    setDuplicateCountry(selectedCountryChange);
  };

  const handleDuplicatePrimaryCurrencyChange = (selectedOption) => {
    const selectedPrimaryCurrency = selectedOption?.map(
      (option) => option.value
    );
    setDuplicatePrimaryCurrency(selectedPrimaryCurrency);
  };

  const handleDuplicateAdditionalCurrencyChange = (selectedOption) => {
    const selectedAdditionalCurrency = selectedOption?.map(
      (option) => option.value
    );
    setDuplicateAdditionalCurrency(selectedAdditionalCurrency);
  };

  const hanldleDuplicateDefaultLanguageChange = (selectedOption) => {
    const selectedDefaultLanguage = selectedOption?.value;
    setDuplicateDefaultLanguage(selectedDefaultLanguage);
  };

  const handleClose = () => {
    onClose(); // Calling the onClose function passed from the parent component
  };

  const handleRoiSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await performHttpRequest(
        "POST",
        `${apiUrl}/roi/addRoi`,
        {
          roi_name: duplicateProjectName || rowData?.name,
          primary_currency:
            duplicatePrimaryCurreny.length > 0
              ? duplicatePrimaryCurreny
              : rowData?.primary_currency
                ? JSON.parse(rowData?.primary_currency)
                : [],
          additional_currency:
            duplicateAdditionaCurrency.length > 0
              ? duplicateAdditionaCurrency
              : rowData?.additionalCurrency
                ? JSON.parse(rowData?.additionalCurrency)
                : [],
          default_language:
            duplicateDefaultLanguage || rowData?.defaultlanguage
              ? rowData.defaultlanguage
              : "",
          country_name:
            duplicateCountry.length > 0
              ? duplicateCountry
              : rowData?.countries
                ? JSON.parse(rowData?.countries)
                : [],
        }
      );

      if (response?.data?.statusCode === 200) {
        toast.success("Roi Duplicated Successfully", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        onClose(true);
      } else {
        toast.error("Roi Duplication failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.responseText);
    }
  };

  return (
    <>

      <div className="fade modal-backdrop show"></div>
      <div className="modal fade show d-block modal-duplicate-roi">

        <Modal.Dialog>
          <Modal.Header closeButton onClick={handleClose}>
            <div className="d-flex flex-wrap">
              <h5>Duplicate project</h5>
              <p> Provide a few details to configure the settings of your calculator </p>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group mb-3">
              <label className="form-label-custom">Please enter the name of the project</label>
              <Input
                type="text"
                view="outlined"
                color="default"
                label=""
                placeholder="Your project name"
                value={rowData?.name}
                clearButton
                fill
                className={"formsinput" + " " + style.card__exp}
                onChange={(e) => setDuplicateProjectName(e.target.value)}
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label-custom"> For which countries is this calculator applicable?* </label>
              <Select
                classNamePrefix="select"
                isClearable
                isMulti={true}
                options={roiCurrencyDuplicate.map((countryString, index) => {
                  return {
                    value: countryString.country_name,
                    label: countryString.country_name,
                  };
                })}
                onChange={handleDuplicateCountryChange}
                // Pass the 'isSelected' property as the 'defaultValue' prop to Select
                defaultValue={(rowData.countries
                  ? JSON.parse(rowData.countries)
                  : []
                ).map((countryString) => ({
                  value: countryString.replace(/"/g, ""),
                  label: countryString.replace(/"/g, ""),
                }))}
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label-custom"> What is the primary currency for your calculator? </label>
              <Select
                classNamePrefix="select"
                isClearable
                isMulti={true}
                onChange={handleDuplicatePrimaryCurrencyChange}
                options={roiCurrencyDuplicate.map((currencyString, index) => {
                  return {
                    value: currencyString.currency_name,
                    label: currencyString.currency_name,
                  };
                })}
                // Pass the 'isSelected' property as the 'defaultValue' prop to Select
                defaultValue={(rowData.primary_currency
                  ? JSON.parse(rowData.primary_currency)
                  : []
                ).map((currencyString) => ({
                  value: currencyString.replace(/"/g, ""),
                  label: currencyString.replace(/"/g, ""),
                }))}
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label-custom"> Which additional currencies would you like to include for your calculator? </label>
              <Select
                classNamePrefix="select"
                isClearable
                isMulti={true}
                onChange={handleDuplicateAdditionalCurrencyChange}
                options={roiCurrencyDuplicate.map((currency, index) => {
                  return {
                    value: currency.currency_name,
                    label: currency.currency_name,
                  };
                })}
                defaultValue={(rowData.additionalCurrency
                  ? JSON.parse(rowData.additionalCurrency)
                  : []
                ).map((currency) => ({
                  value: currency.replace(/"/g, ""),
                  label: currency.replace(/"/g, ""),
                }))}
                // onChange={handleAdditionalCurrencyChange}
                styles={{
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#ffcccb", // Change background color to red
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: "red", // Change text color to white
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: "red", // Change the color of the close icon to red
                  }),
                }}
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label-custom">Select the default language for your calculator</label>
              {/* <Input
                type="text"
                view="outlined"
                color="default"
                label=""
                placeholder="Company name"
                value={rowData?.defaultlanguage}
                clearButton
                fill
                className={"formsinput" + " " + style.card__exp}
              /> */}

              <Select
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={document.body}
                className="custom-select"
                classNamePrefix="select"
                isClearable
                onChange={hanldleDuplicateDefaultLanguageChange}
                options={roiLanguageDuplicate.map((language, index) => {
                  return {
                    value: language.language_name,
                    label: language.language_name,
                  };
                })}
                defaultValue={
                  rowData.defaultlanguage
                    ? {
                      value: rowData.defaultlanguage,
                      label: rowData.defaultlanguage,
                    }
                    : null
                }
              />
            </div>

            <div className="button-wrap d-flex flex-wrap justify-content-center gap-3">
              {/* <button className="btn btn-bordered color-cancel">
                        {" "}
                        Back{" "}
                      </button> */}
              <button className="d-inline-flex align-items-center btn roi-btn-primary" onClick={handleRoiSubmit}>
                {" "}
                <span className="with-icon">Duplicate project</span> <div className="icon">
                  <Svg name="roi-button-arrow" />
                </div>{" "}
              </button>
            </div>
          </Modal.Body>
        </Modal.Dialog>

      </div>
    </>
  );
};

export default DuplicateRoi;
